/**
 * Finds video embeds on the page and wraps them in a container
 * to preserve the aspect ratio at any screen size.
 *
 * Heavily influenced by (and in some places outright copied) FitVids.js (https://github.com/davatron5000/FitVids.js)
 */

var ResponsiveVideos = (function(window, undefined) {

  'use strict';

  /**
   * variables
   */

  var selectors = [
    'iframe[src*="player.vimeo.com"]',
    'iframe[src*="youtube.com"]',
    'iframe[src*="youtube-nocookie.com"]',
    'object',
    'embed'
  ];
  var videos;

  var variables = function() {
    videos = document.querySelectorAll(selectors.toString());
  };


  /**
   * setup
   */

  var setup = function() {
    if (videos) addStyles();

    for (var i = 0, len = videos.length; i < len; i++) {
      var ratio = measure(videos[i]);
      wrap(videos[i], ratio);
    }
  };

  var addStyles = function() {

    // injects a style tag into the head to handle general styling

    var head = document.head || document.getElementsByTagName('head')[0];
    var css = '.fluid-width-video-wrapper{clear:both;height:0;line-height:0;padding:0;position:relative;width:100%;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {height:100%;left:0;position:absolute;top:0;width:100%;}';

    var style = document.createElement('style');

    if (style.styleSheet){
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
  };

  var measure = function(elem) {

    // gets the width and height of the video and
    // returns an aspect ratio

    var attrWidth = parseInt(elem.getAttribute('width'), 10);
    var attrHeight = parseInt(elem.getAttribute('height'), 10);

    var ratioWidth = !isNaN(attrWidth) ? attrWidth : 16;
    var ratioHeight = !isNaN(attrHeight) ? attrHeight : 9;

    return ratioHeight / ratioWidth;
  };

  var wrap = function(elem, aspectRatio) {

    // wraps the video in a div container and adds the aspect ratio
    // as bottom padding (http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/)

    var parent  = elem.parentNode;
    var sibling = elem.nextSibling;

    var wrapper = document.createElement('div');
    wrapper.classList.add('fluid-width-video-wrapper');
    wrapper.style.paddingTop = (aspectRatio * 100) + '%';
    wrapper.appendChild(elem);

    elem.removeAttribute('width');
    elem.removeAttribute('height');

    if (sibling) {
      parent.insertBefore(wrapper, sibling);
    } else {
      parent.appendChild(wrapper);
    }
  };


  /**
   * init
   */

  variables();
  if (videos) setup();

})(window);



// WEBPACK FOOTER //
// ./src/javascript/features/responsive-videos.js